// 面料库存详情表格列配置
export default (that) => [
  {
    field: "fabricStockInNo",
    title:  that.$l('table_label_fabricStockInNo') || '入库编号',
    minWidth: 140,
    align: "center",
  },
  {
    title: that.$l('table_label_fabricStockInWid') || "入库门幅",
    minWidth: 120,
    align: "center",
    slots: { default: "widSlot" },
  },
  {
    title: that.$l('table_label_fabricStockInWeight') || "入库克重", 
    minWidth: 120,
    align: "center",
    slots: { default: "weightSlot" },
  },
  {
    field: "inStockQuantity",
    title: that.$l('table_label_InStockQuantity') || "入库数量",
    minWidth: 120,
    align: "center",
  },
  {
    field: "inStockDate",
    title: that.$l('table_label_inStockDate') || "入库日期",
    minWidth: 120,
    align: "center",
  },
  {
    field: "createByName",
    title: that.$l('table_label_inStockOperator') || "操作人",
    minWidth: 100,
    align: "center",
  },
];